export default __webpack_public_path__ + "static/media/img_step_appliance06.5d127c22.jpg";